import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import OnlineHelp from '../OnlineHelp/OnlineHelp';
import './Tile.css';

const Tile = ({ title, TitleIcon, children, RightContent, helpTag, ...rest }) => (
  <Paper className="tile" {...rest}>
    <header className="tile__header u-pa-full u-fx u-fx-align-center u-fx-space-between">
      <div className="tile__title u-fx u-fx-align-center">
        {TitleIcon ? <TitleIcon className="u-mr-half" /> : null}
        <h4>{title}</h4>
      </div>
      <div className="u-fx u-fx-align-center">
        {RightContent}
        {helpTag ? (
          <div className="tile-online-help">
            <OnlineHelp helpTag={helpTag} />
          </div>
        ) : null}
      </div>
    </header>
    <div className="tile__content u-pa-full">{children}</div>
  </Paper>
);

Tile.propTypes = {
  title: PropTypes.string,
  helpTag: PropTypes.string,
};

Tile.defaultProps = {
  title: '',
  TitleIcon: null,
  RightContent: null,
  helpTag: null,
};

export default Tile;
